'use strict';

var React = require('react');

var useModalProps = function () {
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var onOpen = React.useCallback(function () { return setIsOpen(true); }, []);
    var onClose = React.useCallback(function () { return setIsOpen(false); }, []);
    return { isOpen: isOpen, onOpen: onOpen, onClose: onClose };
};

exports.useModalProps = useModalProps;
//# sourceMappingURL=useModalProps-3f156f63.js.map
